import React from 'react'

interface CTAProps {
  text: string
  fontSize?: string
  backgroundColor?: string
  fontColor?: string
  onClick?: () => void
  link?: string
}

const CTA: React.FC<CTAProps> = ({
  text, 
  fontSize = 'text-[16px]', 
  backgroundColor = 'bg-white', 
  fontColor = 'text-black',
  onClick,
  link
}) => {
  const handleClick = () => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer')
    } else if (onClick) {
      onClick()
    }
  }

  return (
    <button 
      type="button" 
      className={`
        font-ibm-plex-sans 
        font-bold 
        ${fontSize} 
        ${backgroundColor} 
        ${fontColor} 
        px-6 
        py-3 
        rounded-full 
        hover:opacity-80 
        transition-colors
        w-full
      `}
      onClick={handleClick}
    >
      {text}
    </button>
  )
}

export default CTA
